import { Injectable } from '@angular/core';
import { Api } from '../api';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';
import { IMedia } from './interfaces/media.interface';

@Injectable({
  providedIn: 'root'
})
export class MediaService extends Api {

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService,
  ) {
    super(http, authService, 'media');
  }

  download(id: string) {
    location.href = this.apiUrl + '/media/' + id + '/file';
  }

  upload(fileToUpload: File): Observable<IMedia> {
    const endpoint = this.apiUrl + '/media';
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return this.http.post(
      endpoint,
      formData,
      { headers: { Authorization: 'Bearer ' + this.authService.getToken() } }
    ) as Observable<IMedia>;
  }
}
